import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$workspaceId/financeiro/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/w/$workspaceId/financeiro/resumo', params });
  },
});
